/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateOrganizationUserSessionIssuerForm,
  UpdateOrganizationUserSessionIssuerForm$Outbound,
  UpdateOrganizationUserSessionIssuerForm$outboundSchema,
} from "../components/updateorganizationusersessionissuerform.js";

export type UpdateOrganizationUserSessionIssuerSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type UpdateOrganizationUserSessionIssuerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  updateOrganizationUserSessionIssuerForm:
    UpdateOrganizationUserSessionIssuerForm;
};

/** @internal */
export type UpdateOrganizationUserSessionIssuerSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpdateOrganizationUserSessionIssuerSecurity$outboundSchema:
  z.ZodMiniType<
    UpdateOrganizationUserSessionIssuerSecurity$Outbound,
    UpdateOrganizationUserSessionIssuerSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function updateOrganizationUserSessionIssuerSecurityToJSON(
  updateOrganizationUserSessionIssuerSecurity:
    UpdateOrganizationUserSessionIssuerSecurity,
): string {
  return JSON.stringify(
    UpdateOrganizationUserSessionIssuerSecurity$outboundSchema.parse(
      updateOrganizationUserSessionIssuerSecurity,
    ),
  );
}

/** @internal */
export type UpdateOrganizationUserSessionIssuerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  UpdateOrganizationUserSessionIssuerForm:
    UpdateOrganizationUserSessionIssuerForm$Outbound;
};

/** @internal */
export const UpdateOrganizationUserSessionIssuerRequest$outboundSchema:
  z.ZodMiniType<
    UpdateOrganizationUserSessionIssuerRequest$Outbound,
    UpdateOrganizationUserSessionIssuerRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      updateOrganizationUserSessionIssuerForm:
        UpdateOrganizationUserSessionIssuerForm$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        updateOrganizationUserSessionIssuerForm:
          "UpdateOrganizationUserSessionIssuerForm",
      });
    }),
  );

export function updateOrganizationUserSessionIssuerRequestToJSON(
  updateOrganizationUserSessionIssuerRequest:
    UpdateOrganizationUserSessionIssuerRequest,
): string {
  return JSON.stringify(
    UpdateOrganizationUserSessionIssuerRequest$outboundSchema.parse(
      updateOrganizationUserSessionIssuerRequest,
    ),
  );
}
